import * as giftExchangeRecord from '../services/giftExchangeRecord';

export default {
  namespace: 'giftExchangeRecord',

  state: {
    userInfo: null,
    memberPageList: null,
    addMember: null,
    levels: [],
  },

  effects: {
    //商品管理一览列表
    *getQueryOrderPage({ payload: { values } }, { call, put }) {
      const response = yield call(giftExchangeRecord.getQueryOrderPage, values);
      yield put({
        type: 'save',
        payload: {
          queryOrderPage: response?.data,
        },
      });
    },

    *deleteGift({ payload: { values }, callback }, { call }) {
      const res = yield call(giftExchangeRecord.deleteGift, values);
      callback(res);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
